import * as React from 'react';
import { Query } from 'react-apollo';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import { Heading1 } from 'localmed-core';

import style from './CancelAppointmentPage.scss';

import ArrowLeftC from '../../../legacyCore/icons/ArrowLeftC';
import LegacyPanel from '../../../legacyCore/LegacyPanel';
import StaticMap from '../../../legacyCore/StaticMap';
import AppointmentInfo from '../../../shared/components/AppointmentInfo';
import CancelAppointmentForm, {
  query,
  AppointmentPassedWarning,
  AppointmentImminentWarning,
  AppointmentUncancelableWarning,
} from '../../../shared/components/CancelAppointmentForm';
import Unauthorized from '../../../shared/components/Unauthorized';

import { hasPassed, isImminent, isCancelable } from '../../../shared/utils/appointmentUtils';
import isForbidden from '../../../shared/utils/isForbidden';
import { buildAppointmentUrl, getQueryFromLocation } from '../../../shared/utils/urls';
import MainLayout from '../../components/MainLayout/MainLayoutWithData';
import LoadingPage from '../LoadingPage';
import NotFoundPage from '../NotFoundPage';

export default class CancelAppointmentPage extends React.Component {
  render() {
    const {
      match,
      history: { location },
    } = this.props;
    const locationquery = getQueryFromLocation(location);
    return (
      <Query query={query} variables={{ id: match.params.id, patientToken: locationquery.token }}>
        {({ data, loading, error }) => {
          if (loading) return <LoadingPage />;
          if (isForbidden(error)) {
            return (
              <Unauthorized>
                <LoadingPage />
              </Unauthorized>
            );
          }
          if (error) return <MainLayout error={error} />;
          if (!data || !data.appointment) return <NotFoundPage />;

          const { appointment, currentUser } = data;
          const { provider } = appointment;
          const { office } = provider;
          const { phone } = office;
          const appointmentUrl = buildAppointmentUrl(provider.id, appointment.id, {
            patientToken: appointment.patientToken,
            useMainLayout: true,
          });
          let content;
          if (hasPassed(appointment)) {
            content = <AppointmentPassedWarning phone={phone} />;
          } else if (isImminent(appointment)) {
            content = <AppointmentImminentWarning phone={phone} />;
          } else if (isCancelable(appointment)) {
            content = (
              <CancelAppointmentForm
                appointment={appointment}
                currentUser={currentUser}
                useMainLayout
              />
            );
          } else {
            content = <AppointmentUncancelableWarning phone={phone} />;
          }
          return (
            <MainLayout>
              <Helmet>
                <title>Cancel Your Appointment</title>
                <meta name="robots" content="noindex" />
              </Helmet>
              <div className={style['cancel-appointment-page__row']}>
                <div className={style['cancel-appointment-page__main']}>
                  <p className="margin-bottom-none font-size-xs">
                    <Link to={appointmentUrl}>
                      <ArrowLeftC /> Back to Appointment Details
                    </Link>
                  </p>
                  <Heading1 fontWeight="bold" mb="md">
                    Cancel Your Appointment
                  </Heading1>
                  <LegacyPanel size="lg">{content}</LegacyPanel>
                </div>
                <div className={style['cancel-appointment-page__aside']}>
                  <StaticMap
                    className={style['cancel-appointment-page__map']}
                    width="100%"
                    height="192"
                    zoom={12}
                    markers={[{ latitude: office.latitude, longitude: office.longitude }]}
                  />
                  <LegacyPanel px={0} mb={0}>
                    <AppointmentInfo appointment={appointment} large useMainLayout />
                  </LegacyPanel>
                </div>
              </div>
            </MainLayout>
          );
        }}
      </Query>
    );
  }
}
